import React from "react";
import BandleGame from "./BandleGame";

function App() {
  return (
    <div className="App">
      <BandleGame />
    </div>
  );
}

export default App;
